import type {
  PayloadPutMerchflows_merchflowId_,
  ResponsePutMerchflows_merchflowId_,
} from "@CommonApi/merchflows/_merchflowId_";
import { RoutePutMerchflows_merchflowId_ } from "@CommonApi/merchflows/_merchflowId_";
import { routeToUrl } from "@CommonUtils/routes";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToasts } from "src/components/Toasts";
import { useTranslation } from "src/i18n";
import { API, putRequest } from "src/utils/axios";
import { MERCHFLOWS_REVIEWS_QUERY_KEY } from "./reviews";

interface UpdateMerchflowVariables {
  merchflowId: number;
  payload: PayloadPutMerchflows_merchflowId_;
}

const updateMerchflow = async ({ merchflowId, payload }: UpdateMerchflowVariables) =>
  (
    await putRequest<ResponsePutMerchflows_merchflowId_>(
      routeToUrl(`${API}${RoutePutMerchflows_merchflowId_}`, { merchflowId }),
      { payload },
    )
  ).data;

export const useUpdateMerchflowMutation = () => {
  const { toast } = useToasts();
  const { t } = useTranslation("common");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMerchflow,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: MERCHFLOWS_REVIEWS_QUERY_KEY });
    },
    onError: (error) => toast({ title: t("merchflow.saveFailed"), error }),
  });
};
